import { memo, type FC } from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

import { TICK_HEIGHT, X_AXIS_HEIGHT } from "./helpers"
import GridCell from "./GridCell"

interface AxisRulerProps {
  visibleIndexes: number[]
  // 1-based span indexes that get a tick and a label.
  tickIndexes: Set<number>
}

// Same grid as the lanes, so the ticks line up by construction.
const AxisRuler: FC<AxisRulerProps> = ({ visibleIndexes, tickIndexes }) => (
  <Box sx={{ display: "flex", height: TICK_HEIGHT + X_AXIS_HEIGHT }}>
    {visibleIndexes.map((index) => {
      const spanIndex = index + 1
      if (!tickIndexes.has(spanIndex)) return <GridCell key={spanIndex} />
      return (
        <GridCell key={spanIndex}>
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{ width: 1, height: TICK_HEIGHT, bgcolor: "rgba(255,255,255,0.4)" }}
            />
            <Typography
              variant="caption"
              sx={{
                fontSize: "0.55rem",
                color: "text.disabled",
                lineHeight: `${X_AXIS_HEIGHT}px`,
                whiteSpace: "nowrap",
              }}
            >
              {spanIndex}
            </Typography>
          </Box>
        </GridCell>
      )
    })}
  </Box>
)

// Hover-independent too, so it costs nothing after the first render.
export default memo(AxisRuler)
